import { StyledButton } from "./styles";
import { ButtonProps } from "../types";

export const Button = ({ color, children, onClick, link }: ButtonProps) => {
  if (link) {
    return (
      <a href={link} style={{ textDecoration: "none" }}>
        <StyledButton color={color} onClick={onClick}>
          {children}
        </StyledButton>
      </a>
    );
  }

  return (
    <StyledButton color={color} onClick={onClick}>
      {children}
    </StyledButton>
  );
};
